export default {
  ACTIVE: {
    Title: 'Active',
    Color: '#FFE0CC',
    primary: false,
    secondary: false,
  },
  INACTIVE: {
    Title: 'Inactive',
    Color: '#767676',
    primary: false,
    secondary: false,
  },
  LEAD: {
    Title: 'Lead',
    primary: true,
    secondary: false,
    Color: '#DCE9FF',
    ColorBorder: '#C5D8FF',
    ColorSelected: '#4B86F1',
  },
  DETAILS_NEEDED: {
    Title: 'Details Needed',
    primary: true,
    secondary: false,
    Color: '#E9DFFF',
    ColorBorder: '#D4C6FF',
    ColorSelected: '#9A5DEB',
  },
  STALLED: {
    Title: 'Stalled',
    primary: false,
    secondary: true,
    Color: '#767676',
  },
  CG_SEARCH: {
    Title: 'CG Search Queued',
    primary: true,
    secondary: false,
    Color: '#DDE7FF',
    ColorBorder: '#C7D6FF',
    ColorSelected: '#4D63D9',
  },
  CG_SEARCH_ACTIVE: {
    Title: 'CG Search Active',
    primary: true,
    secondary: false,
    Color: '#CDECEF',
    ColorBorder: '#A7DCE2',
    ColorSelected: '#1F7F8A',
  },
  CG_PROFILE_SENT: {
    Title: 'CG Profile Sent',
    primary: true,
    secondary: false,
    Color: '#D6F5FF',
    ColorBorder: '#B8EDF9',
    ColorSelected: '#27A6B5',
  },
  MEET_GREET: {
    Title: 'Meet & Greet Booked',
    primary: true,
    secondary: false,
    Color: '#DDF7E9',
    ColorBorder: '#C1EEDB',
    ColorSelected: '#1E9B55',
  },
  CLOSED_LOST: {
    Title: 'Closed Lost',
    primary: false,
    secondary: true,
    Color: '#767676',
  },
};
